import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeToFourDharmaFriends from "./sections/WelcomeToFourDharmaFriends";
import UpcomingRetreatsPrograms from "../RetreatsPrograms/sections/UpcomingRetreatsPrograms";
import MeetOurTeachers from "./sections/MeetOurTeachers";
import DharmaVoices from "./sections/DharmaVoices";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WelcomeToFourDharmaFriends />
      <MeetOurTeachers />
      <UpcomingRetreatsPrograms />
      <DharmaVoices />
      <Footer />
    </div>;
}